module.exports = __webpack_public_path__ + "img/saudi_arabia.96f1fa9.webp";